import { api } from '@cwd/lib/main';

export interface FeatureFlag {
    FeatureId: string;
    Name: string;
    Users: FeatureFlagUser[];
}

export interface FeatureFlagUser {
    UserId: string;
    Email: string;
}

export async function getFeatureFlags(): Promise<FeatureFlag[]> {
    return api.get('/FeatureFlags');
}

export async function getFeatureFlag(featureId: string): Promise<FeatureFlag> {
    return api.get(`/FeatureFlags/${featureId}`);
}

export async function addUserToFlag(featureId: string, email: string): Promise<FeatureFlagUser> {
    return api.post(`/FeatureFlags/AddUser/${featureId}?email=${encodeURIComponent(email)}`, null);
}

export async function removeUserFromFlag(featureId: string, userId: string): Promise<void> {
    return api.post(`/FeatureFlags/RemoveUser/${featureId}?userId=${userId}`, null);
}

export type BackOfficeUserSearchItem = Record<string, unknown> & { Email: string };

export async function searchBackOfficeUsers(freetext: string): Promise<BackOfficeUserSearchItem[]> {
    if (!freetext) return [];
    const users: BackOfficeUserSearchItem[] = await api.get(`/BackOffice2/User/Search?$top=10&freetext=${encodeURIComponent(freetext)}`);
    return users.map((u) => ({ Email: u.Email }));
}
